<template>
  <div>
    Aksesuar Satışı
    <ul>
      <li>
        - Aksesuar
      </li>
      <li>
        ----- Marka Bazlı Ciro
      </li>
      <li>
        ----- Geçmiş dönem ile değişim oranı %
      </li>
      <li>
        - Oto Kuaför
      </li>
      <li>
        ----- Marka Bazlı Ciro
      </li>
      <li>
        ----- Geçmiş dönem ile değişim oranı %
      </li>
      <li>
        - Lastik
      </li>
      <li>
        ----- Marka Bazlı Ciro
      </li>
      <li>
        ----- Geçmiş dönem ile değişim oranı %
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'AccessorySales',
}
</script>
